var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrendDown = function SvgTrendDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 8a1 1 0 0 0-1 1v5.586l-6.563-6.562a3.45 3.45 0 0 0-4.875 0l-2.577 2.577a1.396 1.396 0 0 1-1.97 0L1.706 6.293A.999.999 0 1 0 .293 7.707l4.308 4.308a3.4 3.4 0 0 0 4.8 0l2.576-2.577a1.45 1.45 0 0 1 2.047 0L20.586 16H15a1 1 0 1 0 0 2h6c1.654 0 3-1.346 3-3V9a1 1 0 0 0-1-1"
  })));
};
export default SvgTrendDown;